import React from "react";
import { Box } from "@mui/material";

const CustomizerOverlay = ({ children }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </Box>
  );
};

export default CustomizerOverlay;
